import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices } from 'react-admin';
import {
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
  FunctionField
} from 'react-admin';
import { PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import { ArrowBack } from '@material-ui/icons';
import { getThumborPic } from '../global'
//import ResetOrderNum from './ProductSort_ResetOrderNum';

{/* 
  import { ProductSortList, ProductSortCreate, ProductSortEdit, ProductSortShow } from './components/ProductSort';

  <Resource name="CMSProductSort" list={ProductSortList} create={ProductSortCreate} edit={ProductSortEdit} show={ProductSortShow} />
  <Resource name="CMSProductSort" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 60 }
  },
});

const useTxtData = {
  page: {
    tableName: 'ProductSort',
  },
  table: {
    id: 'id',
    PProductSortId: '父级分类',
    SortIcon: '分类图标',
    SortName: '分类名称',
    OrderNum: '排序',
    ShowHome: '首页展示',
    HomeOrderNum: '首页排序',
    CreateTime: '创建时间',
  }
};

//分页列表页面
export const ProductSortList = (props) => {
  //筛选器模块
  const Filters = (props) => {
    return (
      <Filter {...props}>
        {/* <TextInput label="ID" source="id" alwaysOn resettable /> */}
        {/* <TextInput label="XX" source="name" alwaysOn resettable /> */}
      </Filter>
    );
  };
  //批量操作模块
  const AssetBulkActionButtons = (props) => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序" {...props} /> */}
        <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = (props) => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton {...props} /><br />
        {/* <ShowButton {...props} /><br /> */}
        <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
      </div>
    );
  }

  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'ASC' }} filters={<Filters />} bulkActionButtons={false} >
      <Datagrid>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        {/* <TextField label={useTxtData.table.id} source="id" /> */}
        {/* <TextField label={useTxtData.table.PProductSortId} source="PProductSortId" /> */}

        {/* <TextField label={useTxtData.table.SortName} source="SortName" /> */}
        <FunctionField label={useTxtData.table.SortName} render={(record) => {
          let { PProductSortId, SortName } = record;
          SortName = PProductSortId > 0 ? `----${SortName}` : SortName;
          return <div>{SortName}</div>
        }} />

        <PreviewImage picResize label={useTxtData.table.SortIcon} source="SortIcon" className={classes.imageField} />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />

        <BooleanField label={useTxtData.table.ShowHome} source="ShowHome" />
        <TextField label={useTxtData.table.HomeOrderNum} source="HomeOrderNum" />

        <TextField label={useTxtData.table.CreateTime} source="CreateTime" />
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const ProductSortShow = (props) => {
  const ShowActions = (props) => {
    const { basePath, data } = props; const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.PProductSortId} source="PProductSortId" />
        <TextField label={useTxtData.table.SortIcon} source="SortIcon" />
        <TextField label={useTxtData.table.SortName} source="SortName" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.CreateTime} source="CreateTime" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const ProductSortEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const ProductSortCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}
      {/* <TextInput label={useTxtData.table.PProductSortId} source="PProductSortId" validate={[]} /> */}
      <ReferenceInput disabled={Edit} allowEmpty={true} label={useTxtData.table.PProductSortId} source="PProductSortId" reference="Admin/CMSProductSort" filter={{ onlyFirstlevel: true }}>
        <SelectInput optionText="SortName" />
      </ReferenceInput>

      <UpLoadFile label={useTxtData.table.SortIcon} source="SortIcon" validate={[required()]} />
      <TextInput label={useTxtData.table.SortName} source="SortName" validate={[required()]} />
      <NumberInput label={useTxtData.table.OrderNum} source="OrderNum" validate={[required()]} defaultValue={0} />

      <BooleanInput label={useTxtData.table.ShowHome} source="ShowHome" defaultValue={false} />
      <NumberInput label={useTxtData.table.HomeOrderNum} source="HomeOrderNum" defaultValue={0} />

      {/* <TextInput label={useTxtData.table.CreateTime} source="CreateTime" validate={[required()]} /> */}
    </SimpleForm>
  );
}